import React, { useState, useEffect } from 'react';
import DynamicTable from "../../../../widgets/dynamicTable/DynamicTable.jsx";
import { useStoreState } from "easy-peasy";
import HelperMetiers360 from "../../../../../services/HelpersMetiers360.js";
import PropTypes from 'prop-types';
import { Alert, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import customAxios from '../../../../../services/axios.js'
import Loader from '../../../../widgets/Loader.jsx';
import useSearchWithParams from '../../../../../hooks/useSearchWithParams.jsx';
import DatePicker from "react-datepicker";

const Webapp2UserPDFTable = ({ uniqueId, userName }) => {

    const { apiData } = useStoreState(state => state.actionSlugs);

    const [pdfs, setPdfs] = useState(null);
    const [pdfsFiltered, setPdfsFiltered] = useState(null);
    const [downloadingPdfEndingUuid, setDownloadingPdfEndingUuid] = useState();

    const [minDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();

    const { searchInput, search, resetSearchBar } = useSearchWithParams({
        placeholder: 'Rechercher par nom',
        delay: 400,
    });

    useEffect(() => {
        resetSearchBar();
        const getUrl = apiData.ACTIONS?.webapp2User?.getProps?.getWebapp2UsersPdf?.url?.replace('uniqueId', uniqueId);

        customAxios.get(getUrl)
            .then(response => {
                setPdfs(response);
                setPdfsFiltered(response);
            });
    }, []);

    useEffect(() => {
        if (pdfs) {
            let newPdfs = [...pdfs];
            if (search !== "") {
                newPdfs = newPdfs?.filter(pdf => HelperMetiers360.isSearchInText(search, pdf.activityTitle))
            }
            if (minDate || maxDate) {
                if (maxDate) {
                    maxDate.setHours(23);
                    maxDate.setMinutes(59);
                }

                const isOnlyMinDate = !!minDate && !maxDate;

                newPdfs = newPdfs?.filter(pdf =>
                    (isOnlyMinDate && pdf.onGoing)
                    ||
                    (!minDate || new Date(pdf.endingDate) >= minDate)
                    &&
                    (!maxDate || new Date(pdf.endingDate) <= maxDate)
                )
            }
            setPdfsFiltered(newPdfs);
        }
    }, [minDate, maxDate, search])

    const sortType = pdfs?.length > 0
        && [
            {
                value: 'activityTitle', label: "Nom de l'activité",
                test: HelperMetiers360.isArrayContainsValue(pdfsFiltered, "activityTitle"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.activityTitle, b.activityTitle),
                display: (pdf) => pdf.activityTitle ?? '-'
            },
            {
                value: 'endingDate', label: 'Date de fin',
                test: pdfsFiltered?.length > 0,
                method: (a, b) => {
                    const dateA = a.endingDate ? new Date(a.endingDate) : Infinity;
                    const dateB = b.endingDate ? new Date(b.endingDate) : Infinity;
                    return dateB - dateA;
                },
                display: (pdf) => pdf?.onGoing ? "En cours" : (pdf.endingDate ? HelperMetiers360.getdisplayDateType(pdf.endingDate, 'day') : '-')
            },
            {
                value: 'endingUuid', label: "Télécharger",
                test: HelperMetiers360.isArrayContainsValue(pdfsFiltered, "endingUuid"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.endingUuid, b.endingUuid),
                display: (pdf) => (pdf.endingUuid && pdf.isShared) ? <Button
                    variant="secondary"
                    className="p-2 m-2"
                    size="sm"
                    onClick={() => {
                        const formData = new FormData();
                        formData.append("endingUuid", pdf.endingUuid);
                        formData.append("webapp2UserUniqueId", uniqueId);
                        setDownloadingPdfEndingUuid(pdf.endingUuid);
                        axios.post(`${process.env.REACT_APP_WEBAPP2_URL}/ressources/activitySummary`, formData, {
                            responseType: "blob",
                        })
                            .then((response) => {
                                const blob = new Blob([response.data], { type: "application/pdf" });
                                const link = document.createElement("a");
                                link.href = URL.createObjectURL(blob);
                                link.download = `${userName}-${pdf?.activityTitle?.replaceAll(' ', '_')}-${HelperMetiers360.getdisplayDateType(pdf.endingDate, 'day')}`;
                                link.click();
                                setDownloadingPdfEndingUuid();
                            });
                    }}
                >{downloadingPdfEndingUuid === pdf.endingUuid ? <Spinner animation="border" size="sm" /> : <i className="fas fa-download" />}</Button> : '-',
                flatDisplay: (pdf) => pdf.endingUuid ? 'Oui' : 'X'
            },
        ];


    const dateFilters = <div className="d-flex align-items-center w-auto mb-3">
        <label className="label-select w-auto">Période&nbsp;:</label>
        <div className="d-flex w-auto">
            <Button id="btnInitFilters" className="shadow" variant="danger" size="sm" onClick={() => setMinDate(null)}>
                <i className="fas fa-redo"></i>
            </Button>
            <DatePicker
                showIcon
                locale='fr'
                id='start'
                dateFormat="dd/MM/yyyy"
                selected={minDate}
                onChange={(date) => setMinDate(date)}
                placeholderText="jj/mm/aaaa"
                maxDate={maxDate}
            />
            <label htmlFor="end" className="m-2">&nbsp;au</label>
            <Button id="btnInitFilters" className="shadow" variant="danger" size="sm" onClick={() => setMaxDate(null)}>
                <i className="fas fa-redo"></i>
            </Button>
            <DatePicker
                showIcon
                locale='fr'
                id='end'
                dateFormat="dd/MM/yyyy"
                selected={maxDate}
                onChange={(date) => setMaxDate(date)}
                placeholderText="jj/mm/aaaa"
                minDate={minDate}
            />
        </div>
    </div>;

    return !pdfs ?
        <Loader />
        : pdfs?.length > 0 ? <>
            {dateFilters}
            {searchInput}
            {pdfsFiltered?.length > 0
                ? < DynamicTable
                    contentTable={pdfsFiltered}
                    contentSort={sortType}
                    valueInitSort="endingDate"
                    index='endingUuid'
                    tableName={"webapp2UserPdf"}
                    filename={`${userName}-Webapp2ActivitiesPDF-${HelperMetiers360.getdisplayDateType(new Date(), 'day')}`}
                />
                : <Alert variant='warning'>Pas de données disponibles</Alert>
            }
        </>
            : <Alert variant='warning'>Pas d'activités disponibles pour cet⋅te utilisateur⋅ice</Alert>;
};

Webapp2UserPDFTable.propTypes = {
    uniqueId: PropTypes.string.isRequired,
    userName: PropTypes.string
};

export default Webapp2UserPDFTable;